import { call, put } from '@redux-saga/core/effects';
import type { CreatePhysicalDocksBulkResult } from 'contracts/PhysicalDocks';
import { api, notify, apiErrorHandler } from 'services';
import {
  CreatePhysicalDocksBulkActions as Actions,
  CreatePhysicalDocksBulkRequestAction as RequestAction,
} from 'store/ducks/physicalDocks';

export function* createPhysicalDocksBulkRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    const { data }: { data: CreatePhysicalDocksBulkResult } = yield call(
      api.post,
      'docks-physical/bulk',
      postData
    );
    const shouldCommit = onSuccess?.();
    if (shouldCommit === false) return;
    notify(
      'success',
      data.createdCount === 1
        ? '1 doca física criada com sucesso'
        : `${data.createdCount} docas físicas criadas com sucesso`
    );
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    const shouldCommit = onFailure?.();
    if (shouldCommit === false) return;
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
